export default __webpack_public_path__ + "static/media/sql.1ffb2ba5.svg";